import { withStyles } from '@material-ui/core';
import { Entity, ctx as L20NContext } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { change, initialize } from 'redux-form';
import { BLUE, GREEN } from '../../_config/consts';
import { convertStandardDeviceCSVtoJSON, generateStandardDevicesTemplateCSV } from '../../_config/utils';
import * as TagManagemetActions from '../../redux/actions/tagsManagement.actions.js';
import * as TagActions from '../../redux/actions/tag.actions';
import * as UtilsActions from '../../redux/actions/utils.actions';
import ExcelIconCustom from '../CustomIcons/ExcelIconCustom.jsx';
import MDAccordion from '../MDAccordion/MDAccordion.jsx';
import ImportStandardDevicesCSVForm from '../forms/ImportStandardDevicesCSVForm.jsx';
import ImportStandardDeviceMissingTagsView from './ImportStandardDeviceMissingTagsView.jsx';
import momentTz from 'moment-timezone';


const styles = {
  boldText: {
    fontWeight: 'bold',
    color: '#3f3f3f',
  },
  warningContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  warningIcon: {
    marginRight: 10,
  },
  descriptionText: {
    color: '#3f3f3f',
  },
  guideSectionTitle: {
    fontSize: 14,
    fontWeight: 'bold',
    color: '#2a2a2a',
    marginBottom: 8,
    marginTop: 12,
  },
  guideField: {
    marginBottom: 8,
    paddingLeft: 10,
  },
  guideFieldName: {
    fontWeight: 'bold',
    color: '#4a4a4a',
    fontSize: 13,
  },
  guideFieldDescription: {
    color: '#6a6a6a',
    fontSize: 12,
    marginLeft: 5,
  },
  guideNote: {
    marginTop: 10,
    padding: 10,
    backgroundColor: '#fff3cd',
    borderRadius: 4,
    fontSize: 12,
    color: '#856404',
  },
};

@connect((state) => ({ credential: state.credentials.selectedCredential }))
class ImportStandardDevicesCSV extends React.Component {  
  
  constructor(props) {
    super(props);
    this.state = {
      devices: [],
      devicesRaw: [],
      tagsToCreate: [],
    };
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(initialize('ImportStandardDevicesCSVForm', { updateIfExists: false, timezone: momentTz.tz.guess() }));
  }

  onDownloadCSVTemplate() {
    generateStandardDevicesTemplateCSV();
  }

  async onImportStandardDevicesCSV(importFormData, devicesRaw) {
    const { onImportStandardDevices } = this.props;
    onImportStandardDevices(devicesRaw, importFormData.updateIfExists, importFormData.timezone);
  }

  onDeleteFile() {
    const { dispatch } = this.props;
    dispatch(change('ImportStandardDevicesCSVForm', 'csvFile', null));
    this.setState({ devices: [], devicesRaw: [], tagsToCreate: [] });
  }

  mergeDevicesByBadgeUID(devices) {
    const groupedDevices = _.groupBy(devices, device => device['badge UID'] || device.deviceId);
    
    const mergedDevices = _.map(groupedDevices, (deviceGroup) => {
      if (deviceGroup.length === 1) {
        return deviceGroup[0];
      }
      
      const baseDevice = { ...deviceGroup[0] };
      
      _.forEach(deviceGroup, (device, index) => {
        if (index === 0) return;
        
        const suffix = `_${index}`;
        
        const fieldsToMerge = [
          'fromDate',
          'fromTime',
          'toDate',
          'toTime',
          'TR1_dailyTimeFrom',
          'TR1_dailyTimeTo',
          'TR1_daysOfTheWeek',
          'TR1_holidays',
          'TR2_dailyTimeFrom',
          'TR2_dailyTimeTo',
          'TR2_daysOfTheWeek',
          'TR2_holidays'
        ];
        
        _.forEach(fieldsToMerge, field => {
          if (device[field]) {
            baseDevice[`${field}${suffix}`] = device[field];
          }
        });
      });
      
      return baseDevice;
    });
    
    return mergedDevices;
  }

  onAnalyzeLockTagsToCreate(devicesRaw, existingLockTags = []) {
    const tagsToCreate = [];
    
    try {
      _.forEach(devicesRaw, device => {
        const lockTags = device && device['lock tags'] ? _.split(device['lock tags'], ',') : [];
        
        _.forEach(lockTags, tag => {
          const formattedTag = _.trim(tag);
          if (!formattedTag) return;
          
          const existingTag = _.find(existingLockTags, systemTag => 
            systemTag && systemTag.name && systemTag.name.toLowerCase() === formattedTag.toLowerCase()
          );
          
          if (!existingTag) {
            const alreadyInList = _.find(tagsToCreate, t => t.name.toLowerCase() === formattedTag.toLowerCase());
            if (!alreadyInList) {
              tagsToCreate.push({ 
                name: formattedTag, 
                color: BLUE, 
                type: L20NContext.getSync('locks'),
                deviceId: device['badge UID'] || device.deviceId 
              });
            }
          }
        });
      });
    } catch (error) {
      console.log(error);
    }
    
    return tagsToCreate;
  }

  async onFileAccepted(file) {
    const { dispatch } = this.props;
    try {
      dispatch(UtilsActions.setSpinnerVisibile(true));
      const devicesRaw = await convertStandardDeviceCSVtoJSON(file[0]);
      const devices = this.mergeDevicesByBadgeUID(devicesRaw);
      const existingLockTags = await dispatch(TagActions.fetchAllLockTags(true));
      const tagsToCreate = this.onAnalyzeLockTagsToCreate(devicesRaw, existingLockTags);
      dispatch(UtilsActions.setSpinnerVisibile(false));
      this.setState({ devices, devicesRaw, tagsToCreate });
    } catch (error) {
      dispatch(UtilsActions.setSpinnerVisibile(false));
    }
  }

  onRemoveDevice(deviceToRemove) {
    const { devices } = this.state;
    const badgeUID = deviceToRemove['badge UID'] || deviceToRemove.deviceId;
    const finalDevices = _.filter(devices, device => (device['badge UID'] || device.deviceId) !== badgeUID);
    this.setState({ devices: finalDevices });
  }

  async onCreateMissingTags() {
    const { tagsToCreate, devicesRaw } = this.state;
    const { dispatch } = this.props;
    try {
      dispatch(UtilsActions.setSpinnerVisibile(true));
      await dispatch(TagManagemetActions.createBatchLockTags(tagsToCreate));
      const existingLockTags = await dispatch(TagActions.fetchAllLockTags(true));
      const devices = this.mergeDevicesByBadgeUID(devicesRaw);
      const remainingTagsToCreate = this.onAnalyzeLockTagsToCreate(devicesRaw, existingLockTags);
      this.setState({ devices, tagsToCreate: remainingTagsToCreate });
      dispatch(UtilsActions.setSpinnerVisibile(false));
    } catch (error) {
      dispatch(UtilsActions.setSpinnerVisibile(false));
    }
  }

  onRemoveTagToCreate(tagName) {
    const { tagsToCreate } = this.state;
    const finalTagsToCreate = _.filter(tagsToCreate, tag => tag.name !== tagName);
    this.setState({ tagsToCreate: finalTagsToCreate });
  }

  renderCSVGuide() {
    const { classes } = this.props;
    
    return (
      <MDAccordion
        title={<Entity entity="csvCompilationGuide" />}
        defaultExpanded={false}
        elevation={2}
        containerstyle={{ marginTop: 25, marginLeft: 10, paddingRight: 20, marginBottom: 150 }}
        contentContainerStyle={{ padding: 15 }}
      >
        <div className={classes.guideSectionTitle}>
          <Entity entity="csvGuideBasicFields" />
        </div>
        
        <div className={classes.guideField}>
          <span className={classes.guideFieldName}>username:</span>
          <span className={classes.guideFieldDescription}>
            <Entity entity="csvGuideUserEmail" />
          </span>
        </div>

        <div className={classes.guideField}>
          <span className={classes.guideFieldName}>badge UID:</span>
          <span className={classes.guideFieldDescription}>
            <Entity entity="csvGuideBadgeUID" />
          </span>
        </div>

        <div className={classes.guideField}>
          <span className={classes.guideFieldName}>badge Type:</span>
          <span className={classes.guideFieldDescription}>
            <Entity entity="csvGuideBadgeType" />
          </span>
          <ul style={{ marginTop: 5, marginBottom: 5, paddingLeft: 25 }}>
            <li style={{ fontSize: 12, color: '#6a6a6a' }}>
              <Entity entity="csvGuideBadgeTypeGenericCard" />
            </li>
            <li style={{ fontSize: 12, color: '#6a6a6a' }}>
              <Entity entity="csvGuideBadgeTypeGenericCardDesfire" />
            </li>
            <li style={{ fontSize: 12, color: '#6a6a6a' }}>
              <Entity entity="csvGuideBadgeTypeIseoCard" />
            </li>
            <li style={{ fontSize: 12, color: '#6a6a6a' }}>
              <Entity entity="csvGuideBadgeTypeIseoCardDesfire" />
            </li>
          </ul>
        </div>

        <div className={classes.guideField}>
          <span className={classes.guideFieldName}>validationMode:</span>
          <span className={classes.guideFieldDescription}>
            <Entity entity="csvGuideValidationMode" />
          </span>
          <ul style={{ marginTop: 5, marginBottom: 5, paddingLeft: 25 }}>
            <li style={{ fontSize: 12, color: '#6a6a6a' }}>
              <Entity entity="csvGuideValidationModeAlwaysValidated" />
            </li>
            <li style={{ fontSize: 12, color: '#6a6a6a' }}>
              <Entity entity="csvGuideValidationModeOneMinute" />
            </li>
            <li style={{ fontSize: 12, color: '#6a6a6a' }}>
              <Entity entity="csvGuideValidationModeOneHour" />
            </li>
            <li style={{ fontSize: 12, color: '#6a6a6a' }}>
              <Entity entity="csvGuideValidationModeDefault" />
            </li>
          </ul>
        </div>

        <div className={classes.guideField}>
          <span className={classes.guideFieldName}>validationPeriod:</span>
          <span className={classes.guideFieldDescription}>
            <Entity entity="csvGuideValidationPeriod" />
          </span>
        </div>

        <div className={classes.guideField}>
          <span className={classes.guideFieldName}>notes:</span>
          <span className={classes.guideFieldDescription}>
            <Entity entity="csvGuideNotes" />
          </span>
        </div>

        <div className={classes.guideField}>
          <span className={classes.guideFieldName}>lock tags:</span>
          <span className={classes.guideFieldDescription}>
            <Entity entity="csvGuideLockTags" />
          </span>
        </div>

        <div className={classes.guideSectionTitle}>
          <Entity entity="csvGuideAccessDates" />
        </div>

        <div className={classes.guideField}>
          <span className={classes.guideFieldName}>fromDate:</span>
          <span className={classes.guideFieldDescription}>
            <Entity entity="csvGuideFromDate" />
          </span>
        </div>

        <div className={classes.guideField}>
          <span className={classes.guideFieldName}>fromTime:</span>
          <span className={classes.guideFieldDescription}>
            <Entity entity="csvGuideFromTime" />
          </span>
        </div>

        <div className={classes.guideField}>
          <span className={classes.guideFieldName}>toDate:</span>
          <span className={classes.guideFieldDescription}>
            <Entity entity="csvGuideToDate" />
          </span>
        </div>

        <div className={classes.guideField}>
          <span className={classes.guideFieldName}>toTime:</span>
          <span className={classes.guideFieldDescription}>
            <Entity entity="csvGuideToTime" />
          </span>
        </div>

        <div className={classes.guideSectionTitle}>
          <Entity entity="csvGuideAccessModes" />
        </div>

        <div className={classes.guideField}>
          <span className={classes.guideFieldName}>togglePassageMode:</span>
          <span className={classes.guideFieldDescription}>
            <Entity entity="csvGuideTogglePassageMode" />
          </span>
        </div>

        <div className={classes.guideField}>
          <span className={classes.guideFieldName}>openOnPrivacy:</span>
          <span className={classes.guideFieldDescription}>
            <Entity entity="csvGuideOpenOnPrivacy" />
          </span>
        </div>

        <div className={classes.guideSectionTitle}>
          <Entity entity="csvGuideTimeRanges" />
        </div>

        <div className={classes.guideField}>
          <span className={classes.guideFieldName}>TR1_dailyTimeFrom:</span>
          <span className={classes.guideFieldDescription}>
            <Entity entity="csvGuideTR1DailyTimeFrom" />
          </span>
        </div>

        <div className={classes.guideField}>
          <span className={classes.guideFieldName}>TR1_dailyTimeTo:</span>
          <span className={classes.guideFieldDescription}>
            <Entity entity="csvGuideTR1DailyTimeTo" />
          </span>
        </div>

        <div className={classes.guideField}>
          <span className={classes.guideFieldName}>TR1_daysOfTheWeek:</span>
          <span className={classes.guideFieldDescription}>
            <Entity entity="csvGuideTR1DaysOfTheWeek" />
          </span>
        </div>

        <div className={classes.guideField}>
          <span className={classes.guideFieldName}>TR1_holidays:</span>
          <span className={classes.guideFieldDescription}>
            <Entity entity="csvGuideTR1Holidays" />
          </span>
        </div>

        <div className={classes.guideField}>
          <span className={classes.guideFieldName}>TR2_*:</span>
          <span className={classes.guideFieldDescription}>
            <Entity entity="csvGuideTR2Fields" />
          </span>
        </div>

        <div className={classes.guideNote}>
          <Entity entity="csvGuideImportantNote" />
        </div>
      </MDAccordion>
    );
  }

  render() {
    const { devices, devicesRaw, tagsToCreate } = this.state;
    return (
      <div style={{ padding: 15, paddingTop: 0 }}>
        {!tagsToCreate || _.isEmpty(tagsToCreate) ? (
          <div>
            <ImportStandardDevicesCSVForm
              devices={devices}
              onSubmit={(fileData) => this.onImportStandardDevicesCSV(fileData, devicesRaw)}
              onFileAccepted={(file) => this.onFileAccepted(file)}
              onDeleteFile={() => this.onDeleteFile()}
              onRemoveDevice={device => this.onRemoveDevice(device)}
            />
            <div style={{ display: 'flex', alignItems: 'center', marginTop: 10, marginLeft: 10 }}>
              <ExcelIconCustom style={{ width: 25, color: GREEN }} />
              <h4 onClick={() => this.onDownloadCSVTemplate()} className="label-responsive link-label" style={{ margin: 0, color: GREEN, fontWeight: 'bold', fontSize: 16, marginLeft: 10 }}>
                <Entity entity="downloadCSVTemplate" />
              </h4>
            </div>
            {this.renderCSVGuide()}
          </div>
        ) : (
          <ImportStandardDeviceMissingTagsView
            tagsToCreate={tagsToCreate}
            onRemoveTag={tagName => this.onRemoveTagToCreate(tagName)}
            onConfirmCreateTags={() => this.onCreateMissingTags()}
            onCancelCreateTags={() => this.setState({ tagsToCreate: [] })}
          />
        )}
      </div>
    );
  }
}

export default withStyles(styles)(ImportStandardDevicesCSV);
